<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" :label-width="100">
      <FormItem label="名称：" prop="name">
        <span>{{form.name}}</span>
      </FormItem>
      <FormItem label="金融公司：" prop="companyName">
        <span>{{form.companyName}}</span>
      </FormItem>
      <FormItem label="每期价格(元)：" prop="stagesPrice">
        <span>{{form.stagesPrice}}</span>
      </FormItem>
      <FormItem label="分期数：" prop="stagesNum">
        <span>{{form.stagesNum}}</span>
      </FormItem>
      <FormItem label="结算方式：" prop="clearingType">
        <span>{{cycleText(form.clearingType)}}</span>
      </FormItem>
      <FormItem label="描述：" prop="remark">
        <span>{{form.remark}}</span>
      </FormItem>
      <FormItem label="状态：" prop="state">
        <span>{{stateText(form.state)}}</span>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: right; padding-top:12px;">
      <Button :loading="loading" type="primary" @click="hide()">关闭</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      ruleStateData: [{
        value: 0,
        label: '有效（上线）'
      }, {
        value: 1,
        label: '无效（下线）'
      }],
      form: {},
      loading: false,
      modalVisible: false,
      financeData: [],
      cycleData: [],
      isDetail: false
    }
  },

  computed: {
    itemTitle() {
      return '查看计费规则'
    },
    title() {
      return this.form.id ? '查看计费规则' : '新增计费规则'
    }
  },
  watch: {},

  mounted() {
    // init
    this.finance()
    this.cycle()
  },

  methods: {
    finance() {
      this.$request.ruleKV('finance').then(resp => {
        this.financeData = resp.data || []
      })
    },

    cycle() {
      this.$request.ruleKV('cycle').then(resp => {
        this.cycleData = resp.data || []
      })
    },

    detail(id) {
      let self = this
      this.form.id = id
      if (id) {
        this.$request.ruleDetail(id).then(resp => {
          self.form = JSON.parse(JSON.stringify(resp.data))
        })
      } else {
        this.$utils.fill(this.form)
        this.form.menus = []
      }
    },

    show() {
      this.modalVisible = true
    },
    hide() {
      this.modalVisible = false
    },
    cycleText(key) {
      let str = ''
      this.cycleData.forEach(item => {
        if (String(item.cKey) === String(key)) {
          str = item.cValue
        }
      })
      return str
    },

    stateText(key) {
      let str = ''
      this.ruleStateData.forEach(item => {
        if (String(item.value) === String(key)) {
          str = item.label
        }
      })
      return str
    }
  }
}

</script>
